import { createContext, useContext, useState } from "react";

const KEY = "atlas_theme";
const ThemeCtx = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => (localStorage.getItem(KEY) === "light" ? "light" : "dark"));
  const toggle = () => {
    const next = theme === "light" ? "dark" : "light";
    document.documentElement.classList.toggle("theme-light", next === "light");
    localStorage.setItem(KEY, next);
    setTheme(next);
  };
  return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
};

export const useTheme = () => useContext(ThemeCtx);
